"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractComponentDefinition = exports.Component = void 0;
var change_case_1 = require("change-case");
var METADATA_KEY = '_salvo_component';
function Component() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    /* eslint-enable @typescript-eslint/naming-convention, max-len */
    // Default options
    var options = {};
    // Implementation
    function decorator(target) {
        return componentImplementation(target, options);
    }
    // Factory - use as @Component({..})
    if (args.length != 1 || typeof args[0] != 'function') {
        var arg = args[0];
        if (typeof arg == 'string') {
            options = {
                selector: arg
            };
        }
        else {
            options = arg;
        }
        return decorator;
    }
    // Direct - use as @Component
    var _a = __read(args, 1), target = _a[0];
    return decorator(target);
}
exports.Component = Component;
// Implementation
function componentImplementation(ctor, options) {
    var name = ctor.name;
    if ((0, change_case_1.paramCase)(name).indexOf('-') === -1) {
        throw new Error("Component name ".concat(name, " is invalid - class name must have at least two words."));
    }
    if (name !== (0, change_case_1.pascalCase)(name)) {
        throw new Error("Compoent name ".concat(name, " is invalid - class name must be in PascalCase."));
    }
    Reflect.defineMetadata(METADATA_KEY, __assign({}, options), ctor);
}
/** @internal */
function extractComponentDefinition(targetCtor) {
    return Reflect.getMetadata(METADATA_KEY, targetCtor) || [];
}
exports.extractComponentDefinition = extractComponentDefinition;
//# sourceMappingURL=Component.js.map